import React, { useState } from 'react';
import clsx from 'clsx';
import { inject, observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import { FormControlLabel, Grid, RadioGroup, Typography } from '@material-ui/core';

import ServiceTitle from './ServiceTitle';
import CustomRadio from '../../button/CustomRadio';
import { CustomButton } from '../../button';
import { IconNotice } from '../../../static/images/icon';
import { PayMethodPreview } from '../../payment';

// 결제구분(데스크톱) — 인성 지급방법과 같은 선택지. 온라인 결제는 닫혀 있고 접수 즉시 인성에 등록된다.
// 옛 결제수단(카드·계좌이체·법인후불·네이버페이·카카오페이)은 흐리게 두고 '현재 사용 불가 · 접수는 가능합니다!'로 보여 준다
export const PAY_ITEMS = [
  { title: '선불', value: '1' },
  { title: '착불', value: '2' },
  { title: '신용', value: '3' },
];

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 20,
    marginBottom: 120,
    padding: '60px 80px 60px 80px',
    '& .radiobox': {
      marginRight: 45,
    },
    '& .succesBtn': {
      width: 340
    }
  },
  left: {
    flex: '1 1 auto',
    maxWidth: 620,
    paddingRight: 40,
  },
  right: {
    flex: 'none',
  },
}));

function PayBox({ qsStore, pageType }) {
  const classes = useStyles();
  const { quickerReg, handleOptions, options, submitting } = qsStore;
  const [payGbn, setPayGbn] = useState(options.payGbn || '1');

  const handleChange = (e) => {
    const value = e.target.value;
    setPayGbn(value);
    handleOptions('payGbn', value);
  }

  return (
    <Grid className={clsx('serviceBox', classes.root)} container direction="column" justify="flex-start" alignItems="flex-start">
      <Grid item >
        <ServiceTitle title="결제구분" />
      </Grid>
      <Grid item style={{ width: '100%', marginTop: 30 }}>
        <Grid container direction="row" justify="space-between" alignItems="flex-start" wrap="nowrap">
          <div className={classes.left}>
            <RadioGroup row value={payGbn} onChange={handleChange}>
              {PAY_ITEMS.map((item) => (
                <Grid key={item.value} item className="radiobox">
                  <FormControlLabel
                    value={item.value}
                    control={<CustomRadio name="payGbn" checked={payGbn === item.value} onChange={handleChange} />}
                    label={
                      <Typography variant="body1" color="textPrimary">{item.title}</Typography>
                    }
                    classes={{ label: 'label' }}
                    style={{ marginRight: 10 }}
                  />
                </Grid>
              ))}
            </RadioGroup>
            <PayMethodPreview />
          </div>
          <Grid item className={classes.right}>
            <Grid container direction="column" justify="flex-start" alignItems="center">
              <CustomButton
                className="succesBtn"
                fullWidth
                variant="contained"
                color="primary"
                disabled={submitting}
                onClick={() => quickerReg(pageType)}
              >{submitting ? '접수 중' : '접수/예약완료'}</CustomButton>
              <Grid container direction="row" justify="center" alignItems="center" style={{ marginTop: 10 }}>
                <img alt="" style={{ marginRight: 10 }} src={IconNotice} />
                <Typography variant="body2" color="primary">
                  선택정보 외 추가 사항이 발생할 경우 추가요금이 발생됩니다.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default inject('qsStore')(observer(PayBox));
